import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import JoinNow from './pages/JoinNow';
import GallerySection from './pages/Gallery';
import AboutUs from './pages/About';
import ContactSection from './pages/Contact/ContactSection';
import GymFacilities from './pages/Services';


function App() {
  return (
    <BrowserRouter>
      <div className="App">
  
        <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/join" element={<JoinNow />} />
  <Route path="/contact" element={<ContactSection />} />
  <Route path="/facility" element={ <GymFacilities/>} />

  <Route path="/gallery" element={<GallerySection />} />
  <Route path="/about" element={<AboutUs />} />
  <Route path="*" element={<div>Page Not Found</div>} />
</Routes>

      </div>
    </BrowserRouter>
  );
}

export default App;
